import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _extends from 'babel-runtime/helpers/extends';

import SearchBar from '@/components/SearchV3/index.vue';
import Pagination from '@/components/Pagination/index.vue';
import TableList from '@/components/TableList/index.vue';
import searchMixin from '@/mixin/search';
import AssistAccountDialog from '@pt/components/assist-account-dialog/index.vue';
import { advertiserAccountList, adAccountUnbind, adAccountDelete } from '@/api/advertiser/manage';
import _ from 'lodash';
import { parseTime } from '@/filters/index';
import { GrantType } from '@pt/api/user/type';

var defaultQuery = {
  page: 1,
  page_size: 15,
  search_field: 'adv_name',
  keyword: '',
  type: '',
  traffic_types: '',
  platform_name: '',
  statuses: []
};

export default {
  components: {
    SearchBar: SearchBar,
    Pagination: Pagination,
    TableList: TableList,
    AssistAccountDialog: AssistAccountDialog
  },
  mixins: [searchMixin],
  data: function data() {
    var keyFieldConfig = [{
      value: 'adv_id',
      label: '广告主ID'
    }, {
      value: 'adv_name',
      label: '广告主名称'
    }, {
      value: 'xmp_ad_account_id',
      label: '广告账号id'
    }, {
      value: 'account_name',
      label: '广告账号名称'
    }, {
      value: 'email',
      label: '广告账号邮箱'
    }];

    var trafficOption = [{
      value: 21,
      label: 'Mintegral'
    }, {
      value: 5,
      label: 'Unity'
    }, { value: 7, label: 'Applovin' }, {
      value: 10,
      label: 'IronSource'
    }, {
      value: 'xmp',
      label: 'Xmp'
    }];

    var xmpOption = [{
      value: 'active',
      label: '已授权'
    }, {
      value: 'unactive',
      label: '已解绑'
    }, {
      value: 'disabled',
      label: '授权失效'
    }, {
      value: 'pending',
      label: '授权中'
    }];

    var statueOption = [{
      value: 'active',
      label: '已授权'
    }, {
      value: 'unactive',
      label: '授权取消'
    }, {
      value: 'disabled',
      label: '授权失效'
    }];

    return {
      tableConfig: {
        lazy: true,
        treeProps: { children: 'sub_accounts', hasChildren: 'hasChildren' },
        indent: 0
      },
      query: _extends({}, defaultQuery),
      pagination: {
        total: 0
      },
      listLoading: true,
      keyFieldConfig: keyFieldConfig,
      trafficOption: trafficOption,
      xmpOption: xmpOption,
      statueOption: statueOption,
      list: [],
      assistAccountDialogVisible: false,
      accountId: 0,
      GrantType: GrantType
    };
  },

  computed: {
    tableColumnConfig: function tableColumnConfig() {
      var _this = this;

      return [{
        label: '广告主id',
        prop: 'adv_id'
      }, {
        label: '广告主名称',
        prop: 'adv_name'
      }, {
        label: '渠道',
        prop: 'traffic_type',
        params: {
          innerHTML: function innerHTML(_ref) {
            var row = _ref.row;

            if (row.type === 'platform') return row.platform_name;

            var temp = _this.trafficOption.find(function (e) {
              return e.value === row.traffic_type;
            });
            return temp ? temp.label : '-';
          }
        }
      }, {
        label: '广告账号Id',
        prop: 'xmp_ad_account_id',
        width: 200
      }, {
        label: '所属Xmp账号ID',
        prop: 'xmp_user_id'
      }, {
        label: '广告账号名称',
        prop: 'account_name'
      }, {
        label: '广告账号邮箱',
        prop: 'email'
      }, {
        label: '状态',
        prop: 'status',
        params: {
          innerHTML: function innerHTML(_ref2) {
            var row = _ref2.row;

            return _this.xmpOption.find(function (e) {
              return e.value === row.status;
            }).label || '-';
          }
        }
      }, {
        label: '创建时间',
        prop: 'created_time',
        params: {
          innerText: function innerText(_ref3) {
            var row = _ref3.row;

            return parseTime(row.created_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        label: '更新时间',
        prop: 'updated_time',
        params: {
          innerText: function innerText(_ref4) {
            var row = _ref4.row;

            return parseTime(row.updated_time, '{y}-{m}-{d} {h}:{i}:{s}');
          }
        }
      }, {
        prop: 'action-cell',
        slot: 'action-cell'
      }];
    },
    formItemList: function formItemList() {
      var _this2 = this;

      var nameKeywordSearchItem = {
        prop: 'keyword',
        type: 'business',
        subtype: 'advertiser-selector',
        params: {
          filterable: true,
          valueKey: 'name',
          clearable: true
        }
      };

      var otherKeywordSearchItem = {
        prop: 'keyword',
        type: 'input',
        params: function params(_ref5) {
          var formValue = _ref5.formValue;

          return {
            disabled: false,
            readonly: false,
            clearable: true,
            style: 'width: 220px;',
            placeholder: formValue.search_field ? '按' + _this2.keyFieldConfig.find(function (item) {
              return item.value === formValue.search_field;
            }).label + '搜索' : '请输入搜索内容'
          };
        }
      };
      var keywordItem = this.query.search_field === 'adv_name' ? nameKeywordSearchItem : otherKeywordSearchItem;

      return [{
        prop: 'search_field',
        type: 'select',
        params: {
          clearable: false,
          filterable: true,
          style: 'width: 220px;',
          options: this.keyFieldConfig,
          placeholder: '请选择搜索类型',
          handleChange: function handleChange(val) {
            _this2.query.keyword = '';
          }
        }
      }, keywordItem, {
        prop: 'traffic_type',
        type: 'select',
        params: {
          clearable: true,
          filterable: true,
          placeholder: '请选择渠道',
          options: this.trafficOption,
          handleChange: function handleChange(val) {
            if (val === 'xmp') {
              _this2.query.type = 'platform';
              _this2.query.platform_name = val;
              delete _this2.query.traffic_types;
            } else {
              _this2.query.type = 'channel';
              _this2.query.traffic_types = val;
              delete _this2.query.platform_name;
            }
          }
        }
      }, {
        prop: 'statuses',
        type: 'select',
        params: {
          clearable: true,
          multiple: true,
          filterable: true,
          'collapse-tags': true,
          placeholder: '状态',
          options: this.xmpOption
        }
      }];
    }
  },

  watch: {
    $route: function $route() {
      this.renderList();
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.renderList();

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },


  methods: {
    renderList: function renderList() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var params, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this4.listLoading = true;
                params = _extends({}, _this4.query);


                if (params.traffic_type) {
                  delete params.traffic_type;
                }

                _context2.prev = 3;
                _context2.next = 6;
                return advertiserAccountList(params);

              case 6:
                res = _context2.sent;

                _this4.list = _.get(res, 'data.data.list') || [];
                _this4.pagination.total = _.get(res, 'data.data.total');
                _this4.listLoading = false;
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](3);

                _this4.listLoading = false;

              case 15:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4, [[3, 12]]);
      }))();
    },
    handleAuthorized: function handleAuthorized(row) {
      var _this5 = this;

      adAccountUnbind({ id: Number(row.id) }).then(function () {
        _this5.renderList();
      }).finally(function () {});
    },
    handleDelete: function handleDelete(row) {
      var _this6 = this;

      adAccountDelete({ id: Number(row.id) }).then(function () {
        _this6.renderList();
      }).finally(function () {});
    },
    resetSearch: function resetSearch() {
      this.query = _extends({}, defaultQuery);
      this.handleResetSearch();
    }
  }
};